import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { TextAreaField } from '../../components/ui/Field';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import type { StepProps } from '../../types/quiz';
export function StepPersonalTouch({
  profile,
  update,
  onNext
}: StepProps) {
  return <div className="flex flex-1 flex-col" data-id="element-138" data-mp="15ve9nnudg1od">
      <Headline data-id="element-139" data-mp="88yq8gidwty6">Ahora viene la parte más especial ✨</Headline>
      <Subtext data-id="element-140" data-mp="8ajmcakckky5">
        ¿Hay algo único de {profile.child_name} que quieras que aparezca en sus experiencias?
      </Subtext>

      <div className="mt-6 space-y-7" data-id="element-141" data-mp="d5p3yx6pvdgf">
        <TextAreaField id="special-detail" value={profile.special_detail} onChange={value => update({
        special_detail: value
      })} rows={5} placeholder="Por ejemplo: le encanta construir cosas con su abuelo, sueña con viajar al espacio o está aprendiendo a andar en bicicleta." data-id="element-142" data-mp="i6ux2w4ah2qh" />

        <TextAreaField id="parent-message" label="¿Qué mensaje te gustaría que recordara? (opcional)" value={profile.parent_message} onChange={value => update({
        parent_message: value
      })} rows={4} placeholder="Quiero que recuerde que confiamos en él y que puede lograr cosas grandes." data-id="element-143" data-mp="3ql3lrt3ox9dd" />
      </div>

      <div className="mt-auto pt-10" data-id="element-144" data-mp="2kz4tg2poixf2">
        <PrimaryButton onClick={onNext} disabled={profile.special_detail.trim().length === 0} data-id="element-145" data-mp="2ky3hlw0ua6wa">
          Ver resumen →
        </PrimaryButton>
      </div>
    </div>;
}